import React from "react";
import { Button, Modal } from "react-bootstrap";

const ConfirmDeleteDialog = ({
  show,
  title = "Hapus Data",
  message = "Yakin ingin menghapus data ini?",
  confirmLabel = "Hapus",
  cancelLabel = "Batalkan",
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteDialog;
